import { useMutation } from '@tanstack/react-query'

import { notifyCurrentUsers } from '../api'

export const useUpdateCurrentUsersMutation = () => {
  return useMutation({
    mutationFn: notifyCurrentUsers,
  })
}
